let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6rsQT")).then(() => parcelRequire('9PFaq'));